"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timerTester = void 0;
var nbrPromiseExpectedPerTest = 1000;
/**
 * Mock Date.now by changing its return value when jest timer functions are used.
 * Simulate time change.
 */
var createTimerTester = function () {
    var oldNowFn = Date.now;
    var spyInstance;
    var now;
    var getNow = function () {
        if (!now) {
            now = oldNowFn();
        }
        return now;
    };
    var triggerPromises = function () { return new Promise(function (resolve) {
        var recursiveImmediates = function (callback, i) {
            if (i === void 0) { i = 0; }
            return setImmediate(function () {
                if (i < nbrPromiseExpectedPerTest) {
                    recursiveImmediates(callback, i + 1);
                }
                else {
                    callback();
                }
            });
        };
        jest.advanceTimersByTime(0);
        recursiveImmediates(resolve);
    }); };
    var advance = function (ms) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    now = getNow() + ms;
                    jest.advanceTimersByTime(ms);
                    return [4 /*yield*/, triggerPromises()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        now: getNow,
        /**
         * Advance time with fake timer, handling promised based timeouts.
         * One setImmediate should be launched for each expected promise.
         */
        advance: function (ms, _a) {
            var _b = _a === void 0 ? {} : _a, runJustBeforeItEnds = _b.runJustBeforeItEnds;
            return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!runJustBeforeItEnds) return [3 /*break*/, 3];
                            return [4 /*yield*/, advance(ms - 50)];
                        case 1:
                            _c.sent();
                            runJustBeforeItEnds();
                            return [4 /*yield*/, advance(50)];
                        case 2:
                            _c.sent();
                            return [3 /*break*/, 4];
                        case 3: return [2 /*return*/, advance(ms)];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        waitTimer: function (promise) { return __awaiter(void 0, void 0, void 0, function () {
            var i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < 3)) return [3 /*break*/, 5];
                        return [4 /*yield*/, advance(Infinity)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, triggerPromises()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/, promise];
                }
            });
        }); },
        endTimer: function () {
            var promises = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                promises[_i] = arguments[_i];
            }
            return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            jest.runAllTimers();
                            return [4 /*yield*/, Promise.all(promises)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        triggerPromises: triggerPromises,
        beforeTest: function () {
            jest.useFakeTimers();
            spyInstance = jest.spyOn(Date, 'now').mockImplementation(getNow);
        },
        afterTest: function () {
            jest.clearAllTimers();
            jest.useRealTimers();
            spyInstance === null || spyInstance === void 0 ? void 0 : spyInstance.mockRestore();
            spyInstance = undefined;
            now = undefined;
        }
    };
};
exports.timerTester = createTimerTester();
